import React from 'react';
import { TableRow, TableCell, Checkbox, Chip, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const STATUS_MAP = {
    active:      { ar: 'نشط',     en: 'Active',      color: 'success' },
    transferred: { ar: 'منقول',    en: 'Transferred', color: 'info' },
    completed:   { ar: 'مكتمل',    en: 'Completed',   color: 'primary' },
    cancelled:   { ar: 'ملغي',     en: 'Cancelled',   color: 'error' },
};

const StudentEnrollmentsTableRow = ({ item, index, isArabic, isDark, page, perPage, order, totalItems, selectedIds, onRowCheckboxClick, onMenuOpen }) => {
    const serial = order === 'asc' ? (page - 1) * perPage + index + 1 : (page - 1) * perPage + (totalItems - index);
    const isOdd = index % 2 === 0;
    const isSelected = selectedIds.includes(item?.id);
    const st = STATUS_MAP[item?.status] || STATUS_MAP.active;

    return (
        <TableRow hover role="checkbox" aria-checked={isSelected} selected={isSelected}
            sx={{ cursor: 'pointer', '&:last-child td, &:last-child th': { border: 0 },
                backgroundColor: isDark ? (isOdd ? '#020617' : '#050816') : (isOdd ? '#F2F7FF' : '#FFFFFF'),
                '&:hover': { backgroundColor: isDark ? '#111827' : '#E3F2FD' }, transition: 'background-color 0.15s ease' }}>
            <TableCell padding="checkbox"><Checkbox color="primary" checked={isSelected} onChange={(e) => onRowCheckboxClick(e, item?.id)} /></TableCell>
            <TableCell align="center">{serial}</TableCell>
            <TableCell align="center">{item?.student_name || '-'}</TableCell>
            <TableCell align="center">{item?.class_name || '-'}</TableCell>
            <TableCell align="center">{item?.level_name || '-'}</TableCell>
            <TableCell align="center">{item?.academic_year_name || '-'}</TableCell>
            <TableCell align="center">{item?.joined_at || '-'}</TableCell>
            <TableCell align="center">{item?.left_at || '-'}</TableCell>
            <TableCell align="center">
                <Chip label={isArabic ? st.ar : st.en} size="small" color={st.color}
                    variant={item?.status === 'active' ? 'filled' : 'outlined'} sx={{ fontWeight: item?.status === 'active' ? 600 : 400 }} />
            </TableCell>
            <TableCell align="center">
                <IconButton size="small" onClick={(e) => { e.stopPropagation(); onMenuOpen(e, item); }}
                    sx={{ color: isDark ? '#E5E7EB' : '#1F2937' }}><MoreVertIcon fontSize="small" /></IconButton>
            </TableCell>
        </TableRow>
    );
};

export default StudentEnrollmentsTableRow;
